import { projects } from './projects';
import { transcripts } from './transcripts';
import { workspaces } from './workspaces';

export const queryKeys = {
  transcripts,
  workspaces,
  projects,
};
